import { Link } from 'lucide-react';

const integrationCategories = [
  {
    name: 'FCMs',
    color: 'from-purple-500 to-cyan-500',
    bgColor: 'from-purple-50 to-cyan-50',
    borderColor: 'border-purple-200',
    partners: ['ADM Investor Services', 'Marex', 'StoneX', 'RJ O\'Brien', 'INTL FCStone', 'Straits Financial'],
  },
  {
    name: 'Exchanges',
    color: 'from-purple-500 to-purple-400',
    bgColor: 'from-purple-50 to-slate-50',
    borderColor: 'border-purple-200',
    partners: ['CME Group', 'ICE', 'CBOT', 'NYMEX', 'COMEX', 'Nodal Exchange'],
  },
  {
    name: 'Platforms',
    color: 'from-cyan-500 to-cyan-400',
    bgColor: 'from-cyan-50 to-slate-50',
    borderColor: 'border-cyan-200',
    partners: ['Trading Technologies', 'CQG', 'ION', 'Bloomberg', 'Refinitiv', 'Symphony'],
  },
];

function LogoPlaceholder({ name }: { name: string }) {
  return (
    <div className="flex items-center justify-center h-20 px-4 rounded-xl bg-white border border-slate-200 hover:border-purple-300 hover:shadow-md transition-all cursor-pointer">
      <span className="font-semibold text-sm text-center text-slate-700">{name}</span>
    </div>
  );
}

export function IntegrationPartnersSection() {
  return (
    <section id="integrations" className="relative py-20 md:py-28 bg-slate-50">
      <div className="container relative">
        {/* Section Header */}
        <div className="mx-auto max-w-2xl text-center mb-12">
          <div className="inline-flex items-center gap-2 rounded-full bg-slate-100 border border-slate-200 px-4 py-1.5 text-sm mb-6">
            <Link className="h-4 w-4 text-purple-600" />
            <span className="text-slate-700 font-medium">Integrations</span>
          </div>
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl mb-4 text-slate-900">
            <span className="text-purple-600">
              Seamless
            </span>{' '}
            Integrations
          </h2>
          <p className="text-lg text-slate-600">
            Connect with the platforms and partners you already use. We support all major FCMs, exchanges, and trading systems.
          </p>
        </div>

        {/* Integration Categories */}
        <div className="space-y-12">
          {integrationCategories.map((category) => (
            <div key={category.name}>
              <div className="flex justify-center mb-6">
                <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-100 border border-slate-200 text-slate-700 font-semibold text-sm">
                  {category.name}
                </span>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4">
                {category.partners.map((partner) => (
                  <LogoPlaceholder key={partner} name={partner} />
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Note */}
        <p className="mt-12 text-center text-sm text-slate-500">
          Don't see your platform?{' '}
          <a href="#demo" className="text-purple-600 font-medium hover:underline">
            Contact us
          </a>{' '}
          for custom integrations.
        </p>
      </div>
    </section>
  );
}
